<template>
    <div>
        <span>
            © 2013 - 2019 广州绿网环境保护服务中心版权所有，并保留所有权利 粤ICP备15063264号-1
        </span>
        <ul>
            <li @click='handleClick("http://www.lvwang.org.cn/article/show/?id=59")'> 数据反馈</li>
            <li @click='handleClick("http://www.lvwang.org.cn/article/show/?id=15")'> 关于我们</li>
            <li @click='handleClick("http://www.lvwang.org.cn/article/show/?id=16")'> 免责声明</li>

        </ul>

    </div>
</template>

<script>
    export default {
        name: "Foot2",
        methods: {
            handleClick(val) {
                console.log(val)
                window.open(val)
            },
        }
    }
</script>

<style scoped>
    div {
        /*width: 200px;*/
        height: 60px;
        font-size: 16px;
        background-color: #f7f7f7;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        box-shadow: 0 0 6px #75bd35;
    }

    ul {
        display: flex;
        text-align: center;
    }

    ul li {
        padding-left: 20px;
    }

    li:hover {
        cursor: pointer;
        color: yellowgreen;
    }
</style>